document.addEventListener('DOMContentLoaded', function() {
  var forms = document.querySelectorAll('.umbraco-forms-form form');
  for(let j = 0; j < forms.length; j++) {
    forms[j].addEventListener('submit', function (event) {
      var form = event.target;
      if (form.hasAttribute('data-submitting')) {
        event.preventDefault();
      } else {
        form.setAttribute('data-submitting', '');
      }
    });
  }
}); 